import { create } from 'zustand';
import { createBrandingSlice } from './createBrandingStore';
import { createComponentValueSlice } from './createComponentValueStore';
import { createDocumentAttachmentsSlice } from './createDocumentAttachmentsStore';
import { createDocumentTransactionSlice } from './createDocumentTransactionStore';
import { createEsignDocumentSlice } from './createEsignDocumentStore';
import { createPersonalSettingsSlice } from './createPersonalSettingsStore';
import { createSignatureRequestMetadataSlice } from './createSignatureRequestMetadataStore';
import { createSignaturesSlice } from './createSignaturesStore';
import { createSignerPaymentsSlice } from './createSignerPaymentsStore';
import { createSignersSlice } from './createSignersStore';
import { createSignerSlice } from './createSignerStore';
import { AppStore } from './types';

export const storeResetFns = new Set<() => void>();

export const useAppStore = create<AppStore & { resetStore: () => void }>((...args) => ({
	...createComponentValueSlice(...args),
	...createSignerSlice(...args),
	...createSignaturesSlice(...args),
	...createDocumentAttachmentsSlice(...args),
	...createEsignDocumentSlice(...args),
	...createPersonalSettingsSlice(...args),
	...createSignerPaymentsSlice(...args),
	...createSignersSlice(...args),
	...createDocumentTransactionSlice(...args),
	...createSignatureRequestMetadataSlice(...args),
	...createBrandingSlice(...args),
	resetStore: () => {
		storeResetFns.forEach(fn => fn());
	},
}));
